import hc_slider from '@iris.interactive/handcook/public/scripts/components/slider/slider.component'

export default class HeaderService {
    static cssSelector = '#header-banner-slider'

    constructor() {
        HeaderService.initSlider()
        HeaderService.lang()
    }

    static initSlider() {
        hc_slider(HeaderService.cssSelector);
        document.querySelector(HeaderService.cssSelector).addEventListener('init.hc.slider', () => {
            $('.header__content').addClass('header-slider-is-init')
        })
    }

    static lang() {
        const switcher = '[data-trigger="lang-switcher"]'
        const list = '[data-id="lang-switcher-list"]'

        // Switch current language
        $(document).on('click', `${list} a`, function () {
            $(switcher).text($(this).text())
            $(list).removeClass('lang-switch__list--open')
        })

        $(switcher).on('click', () => {
            $(list).toggleClass('lang-switch__list--open')
        })

        $(window).on('load scroll', () => {
            if ($('body').hasClass('header-is-hidden')) {
                $(list).removeClass('lang-switch__list--open')
            }
        })

        $(document).on('click', (e) => {
            if (!$(switcher).is(e.target) && $(switcher).has(e.target).length === 0) {
                $(list).removeClass('lang-switch__list--open')
            }
        })
    }
}
